import {
  CashoutMethods,
  PaymentMethodTypeEnum,
  PaymentMethods,
} from '../interfaces'
import { api } from '@utils/api/api'

export const getCashoutMethods = (): Promise<CashoutMethods> => {
  return api.get('/api/v1/customers/me/payment-methods/withdraw')
}
export const getPaymentMethods = (): Promise<PaymentMethods> => {
  return api.get('/api/v1/customers/me/payment-methods')
}

export const deletePaymentMethod = (
  paymentMethodId: string,
  type: PaymentMethodTypeEnum,
): Promise<void> => {
  switch (type) {
    case PaymentMethodTypeEnum.card:
      return api.delete(`/api/v1/card-payments/cards/${paymentMethodId}`)
    case PaymentMethodTypeEnum.manualTransfer:
      return api.delete(`/api/v1/manual-transfer-template/${paymentMethodId}`)
    default:
      return api.delete(
        `/api/v1/customers/me/payment-methods/${paymentMethodId}`,
      )
  }
}

export const setPaymentMethod = (paymentMethodId: string): Promise<void> => {
  return api.patch(`/api/v1/customers/me/payment-methods/${paymentMethodId}`, {
    default: true,
  })
}

export const getPaymentMethodStatus = (
  paymentMethodId: string,
): Promise<void> => {
  return api.get(
    `/api/v1/customers/me/payment-methods/${paymentMethodId}/status`,
  )
}
